import axios from "axios";

const isLoggedin = () => {
  return (
    typeof window?.localStorage !== "undefined" &&
    !!localStorage.getItem("ExanGridToken")
  );
};

// Create axios instance
export const apiClient = axios.create({
  baseURL: "https://api.niveshhindustan.com/",
});

// Attach default headers
const attachAuthHeaders = () => {
  const token = localStorage.getItem("ExanGridToken");
  return isLoggedin() && token ? { Authorization: `Bearer ${token}` } : {};
};

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          return Promise.reject(error.response);
        case 403:
          break;
        case 404:
          break;
        case 401:
          window.location.href = "/login";
          break;
        case 415:
          break;
        case 422:
          break;
        case 423:
          break;
        case 500:
          break;
        default:
      }
    } else if (error.request) {
      console.error("No response received from the server");
    } else {
      console.error("Request error:", error.message);
    }

    return Promise.reject(error.response);
  },
);

// Fetcher object
const fetcher = {
  async request(
    method: string,
    endpoint: string,
    data: any = null,
    params: any = null,
    isFile: boolean = false,
  ) {
    const headers: any = attachAuthHeaders();
    if (isFile) headers["Content-Type"] = "multipart/form-data";

    try {
      const response = await apiClient.request({
        method,
        url: endpoint,
        data,
        params,
        headers,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  get(endpoint: string, params = null) {
    return this.request("get", endpoint, null, params);
  },

  post(endpoint: string, data: any) {
    return this.request("post", endpoint, data);
  },

  patch(endpoint: string, data: any = null) {
    return this.request("patch", endpoint, data);
  },

  delete(endpoint: string) {
    return this.request("delete", endpoint);
  },

  put(endpoint: string, data: any) {
    return this.request("put", endpoint, data);
  },

  postFile(endpoint: string, formData: FormData) {
    return this.request("post", endpoint, formData, null, true);
  },

  putFile(endpoint: string, formData: FormData) {
    return this.request("put", endpoint, formData, null, true);
  },
};

export default fetcher;
